/**
 * Vault フォームのパスワード欄に出す軽量な強度推定。
 *
 * RegisterPage の強度メータは zxcvbn-ts (ja/en 辞書 ~900 KB raw) を使うが、
 * これは register chunk に閉じ込めてあり (past-11)、vault バンドルには持ち込まない。
 * vault フォームでは「文字種 + 長さ」のヒューリスティックで十分な目安を出す。
 *
 * 戻り値 0..4:
 *   0 = 未入力 (空文字)
 *   1 = 弱い / 2 = 普通 / 3 = 強い / 4 = 非常に強い
 */
export type PasswordHeuristicScore = 0 | 1 | 2 | 3 | 4

export const scorePasswordHeuristic = (password: string): PasswordHeuristicScore => {
  if (password === '') return 0

  // 8 文字未満は文字種を満たしても「弱い」止まり。
  if (password.length < 8) return 1

  let score = 0
  if (password.length >= 12) score += 1
  if (/[A-Z]/u.test(password) && /[a-z]/u.test(password)) score += 1
  if (/[0-9]/u.test(password)) score += 1
  if (/[^A-Za-z0-9]/u.test(password)) score += 1

  // 8 文字以上あれば最低でも「弱い」(score 0 を 1 に底上げ)。
  return Math.max(1, score) as PasswordHeuristicScore
}
